import subs from '../DummyData/subscriptions.json';
import { subscription } from './AuthDataTypes';

export const fetchSubscriptions = async (userId: string): Promise<subscription[]> => {
    let prom: subscription[] = [];
    const response = subs.find((s) => s.userId == userId);
    
    if (response?.subscriptions && response.subscriptions.length > 0) {
        prom = response.subscriptions as subscription[];
    }

    return prom;
}